{
  "_provenance": {
    "ns": "common",
    "source": "shared — actions, states and the language banner used by three or more surfaces"
  },
  "actions": {
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "continue": "Continue",
    "delete": "Delete",
    "details": "Details",
    "dismiss": "Dismiss",
    "edit": "Edit",
    "hideDetails": "Hide details",
    "next": "Next",
    "previous": "Previous",
    "retry": "Try again",
    "save": "Save",
    "saveChanges": "Save changes",
    "undo": "Undo"
  },
  "answers": {
    "no": "No",
    "none": "None",
    "uploadedFile": "Uploaded file",
    "yes": "Yes"
  },
  "errorState": {
    "refreshToTryAgain": "Refresh the page to try again."
  },
  "filterToolbar": {
    "clear": "Clear",
    "clearAll": "Clear all",
    "clearPill": "Clear {{label}}",
    "clearSearch": "Clear search",
    "done": "Done",
    "filters": "Filters",
    "searchDialogDescription": "The list filters as you type. Close to keep the search; clear the pill to drop it.",
    "searchPill": "Search: {{value}}",
    "toolbarLabel": "{{title}} toolbar"
  },
  "items_one": "{{count}} item",
  "items_other": "{{count}} items",
  "language": {
    "label": "Language",
    "machineTranslatedBanner": "Machine-translated — TRF has not reviewed this language yet",
    "machineTranslatedShort": "Machine-translated",
    "report": {
      "action": "Report a translation",
      "failed": "We couldn’t send your report. Please try again.",
      "lede": "Tell TRF which words on this page read wrong. We send the page address, the language, any words you selected and your note.",
      "noSelection": "Tip: select the words on the page first, then open this, and they’re included.",
      "noteLabel": "What reads wrong?",
      "selectedLabel": "Words you selected",
      "send": "Send",
      "sending": "Sending…",
      "thanksBody": "TRF’s language reviewer will look at it. Thank you for helping families read this clearly.",
      "thanksTitle": "Thank you, we got it",
      "title": "Report a translation"
    },
    "showOriginal": "Show original"
  },
  "links": {
    "opensInNewTab": "opens in a new tab"
  },
  "offline": {
    "banner": "You’re offline — showing your last update. {{companion}} will be fully available when you’re back online."
  },
  "pagination": {
    "posts_one": "{{count}} post",
    "posts_other": "{{count}} posts",
    "range": "Showing {{from}}–{{to}} of {{total}}",
    "rangeOfItems": "Showing {{from}}–{{to}} of {{items}}",
    "threads_one": "{{count}} thread",
    "threads_other": "{{count}} threads",
    "users_one": "{{count}} user",
    "users_other": "{{count}} users"
  },
  "pendingDecision": {
    "alsoConsidered": "We also considered",
    "ariaLabel": "Pending decision: {{question}} Currently: {{chose}}. Open to see the alternatives.",
    "feedbackInvite": "We picked this so you could see it working. If it should be one of the others — or something else entirely — say so with <strong>Send feedback</strong> and we will change it.",
    "label": "Pending decision",
    "rightNow": "Right now it says <strong>{{chose}}</strong> — {{because}}",
    "titleWithRef": "Pending decision — {{ref}}"
  },
  "sectionNav": {
    "label": "Sections"
  },
  "states": {
    "error": "Something went wrong",
    "loading": "Loading…",
    "pleaseTryAgain": "Please try again.",
    "saved": "Saved",
    "saving": "Saving…"
  },
  "time": {
    "justNow": "just now"
  },
  "toast": {
    "label": "Notification",
    "viewportLabel": "Notifications ({hotkey})"
  },
  "toolbar": {
    "add": "Add",
    "closeSearch": "Close search",
    "filter": "Filter",
    "search": "Search",
    "tools": "{{label}} tools"
  }
}
